import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import Catalog from 'blocks.app/catalog/catalog'
import Sidebar from 'blocks.app/sidebar/sidebar'
import Rectangle from 'blocks.simple/rectangle/rectangle'
import Icon from 'blocks.simple/icon/icon'
import Button from 'blocks.simple/button/button'
import { cn } from 'ethcss'
import styles from './report_tasks.jcss'
import translate from 'core/translate'
import { grid, item } from '../../../theme'
import { api } from 'core/api/ConnectionManager'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import Modal from '../../../blocks.simple/modal/modal'
import ReportChart from '../_chart/ReportChart'
import { useDispatch } from 'react-redux'
import { emitError } from 'features/appNotifications/AppNotifications.state'
import moment from 'moment/moment'

type SelectedInfo = {
    status: string
    url: string
    id: number
    reportType: string
}

const ReportTasks = () => {
    const [selectedInfo, setSelectedInfo] = useState<SelectedInfo | null>(null)
    const [selectedItems, setSelectedItems] = useState([])
    const [selectedForAbort, setSelectedForAbort] = useState<number[]>([])
    const [selectedForDelete, setSelectedForDelete] = useState<number[]>([])
    const [open, setOpen] = useState(false)
    const dispatch = useDispatch()

    const onClose = () => {
        setOpen(false)
    }

    const onCancel = () => {
        setSelectedForAbort([])
        setSelectedForDelete([])
    }

    const renderConfirmModal = () => {
        const title = selectedForAbort.length
            ? 'Вы действительно хотите прервать выполнение?'
            : 'Вы действительно хотите удалить выбранные отчеты?'
        const description = selectedForAbort.length
            ? 'Выполнение будет прервано без возможности возобновления'
            : 'Выбранные отчеты будут удалены без возможности восстановления'

        return (
            <div className={styles.confirmModal}>
                <div className={styles.confirmModalInner}>
                    <div className={styles.confirmModalTitle}>{title}</div>
                    <div className={styles.confirmModalDescription}>{description}</div>
                    <div className={styles.buttons}>
                        <Button
                            mod={'withBorder'}
                            className={styles.button}
                            textSize={'mini'}
                            indentSize={'mini'}
                            rounded={'full_normal'}
                            onClick={onCancel}
                        >
                            {translate('cancel')}
                        </Button>
                        <Button
                            mod={'fill'}
                            className={styles.button}
                            textSize={'mini'}
                            indentSize={'mini'}
                            rounded={'full_normal'}
                            onClick={() => {
                                if (selectedForAbort.length) {
                                    api.send('abortReportTask', {
                                        reportTaskId: selectedForAbort,
                                    }).then(() => {
                                        dispatch(
                                            emitError(
                                                translate('abortReportTaskByUser') +
                                                    moment().format('HH:mm:ss DD.MM.YYYY')
                                            )
                                        )
                                        setSelectedForAbort([])
                                        setSelectedItems([])
                                        setSelectedInfo(null)
                                    })

                                    return
                                }

                                api.send('deleteReportTask', { id: selectedForDelete }).then(() => {
                                    setSelectedForDelete([])
                                    setSelectedItems([])
                                    setSelectedInfo(null)
                                })
                            }}
                        >
                            {translate('submit')}
                        </Button>
                    </div>
                </div>
            </div>
        )
    }

    const renderSelectedInfo = () => {
        return (
            selectedInfo && (
                <div className={cn(grid.col, grid.justify, grid.space)}>
                    <div>
                        <Rectangle>
                            <div className={cn(styles.iconWrapper)}>
                                <Icon
                                    containerClass={cn(grid.space, grid.full, grid.colCenter)}
                                    type={'table'}
                                    size={'70%'}
                                    color={'white'}
                                />
                            </div>
                        </Rectangle>
                        <div className={cn(item.shadowButton)}>
                            {selectedInfo && selectedInfo.status === 'in_progress' && (
                                <div
                                    className={cn(styles.menuItem)}
                                    onClick={() => {
                                        setSelectedForAbort([selectedInfo.id])
                                    }}
                                >
                                    {translate('abortReport')}
                                </div>
                            )}
                            {selectedInfo && selectedInfo.url && (
                                <a
                                    className={cn(styles.menuItem, {
                                        [item.disabled]: !selectedInfo.url,
                                    })}
                                    rel="noopener noreferrer"
                                    href={selectedInfo.url}
                                    download={true}
                                >
                                    {translate('download')}
                                </a>
                            )}
                            {selectedInfo && selectedInfo.reportType === 'digitalSignageReport' && (
                                <div className={cn(styles.menuItem)} onClick={() => setOpen(true)}>
                                    {translate('show')}
                                </div>
                            )}
                            <div
                                className={cn(styles.menuItem)}
                                onClick={() => setSelectedForDelete([selectedInfo.id])}
                            >
                                {translate('delete')}
                            </div>
                        </div>
                    </div>
                    <div className={cn(grid.p_md, grid.rowCenter)}>
                        <Button onClick={() => setSelectedInfo(null)} mod={'withBorder'}>
                            {translate('deselect')}
                        </Button>
                    </div>
                </div>
            )
        )
    }

    const renderSelectedItems = () => {
        return (
            <div className={cn(grid.col, grid.justify, grid.space)}>
                <div>
                    <Rectangle>
                        <div className={cn(styles.iconWrapper)}>
                            <Icon
                                containerClass={cn(grid.space, grid.full, grid.colCenter)}
                                type={'table'}
                                size={'70%'}
                                color={'white'}
                            />
                        </div>
                    </Rectangle>
                    <div className={cn(item.shadowButton)}>
                        {selectedItems.some((item: any) => item.status === 'in_progress') && (
                            <div
                                className={cn(styles.menuItem)}
                                onClick={() => {
                                    setSelectedForAbort(
                                        selectedItems
                                            .filter((item: any) => item.status === 'in_progress')
                                            .map((item: any) => item.id)
                                    )
                                }}
                            >
                                {translate('abortReport')}
                            </div>
                        )}
                        {selectedItems.some((item: any) => item.status !== 'in_progress') && (
                            <div
                                className={cn(styles.menuItem)}
                                onClick={() =>
                                    setSelectedForDelete(
                                        selectedItems
                                            .filter((item: any) => item.status !== 'in_progress')
                                            .map((item: any) => item.id)
                                    )
                                }
                            >
                                {translate('delete')}
                            </div>
                        )}
                    </div>
                </div>
                <div className={cn(grid.p_md, grid.rowCenter)}>
                    <Button onClick={() => setSelectedItems([])} mod={'withBorder'}>
                        {translate('deselect')}
                    </Button>
                </div>
            </div>
        )
    }

    return (
        <Content
            title={translate('reportTasks')}
            toolbar={
                <Sidebar
                    selectedSide={'right'}
                    customContent={{
                        right: selectedItems.length
                            ? renderSelectedItems()
                            : selectedInfo
                            ? renderSelectedInfo()
                            : null,
                    }}
                    isEmpty={{
                        right: !selectedInfo && !selectedItems.length,
                    }}
                    emptyText={{
                        right: {
                            title: translate('noSelectedReports'),
                            description: translate('noSelectedReportsDescription'),
                        },
                    }}
                />
            }
        >
            <Catalog
                type={'reportTasks'}
                selectedInfo={selectedInfo}
                onSelectInfo={(selectedInfo: SelectedInfo) => setSelectedInfo(selectedInfo)}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                hideHeader={true}
                selectAllCheckbox={true}
                treeView={false}
            />
            {selectedInfo && selectedInfo.reportType === 'digitalSignageReport' && (
                <Modal open={open} showCloseIcon={true} onClose={onClose} mod={'white'} transitionName={'fade'}>
                    <div className={styles.modalWrapper}>
                        <ReportChart
                            selectedInfo={selectedInfo}
                            params={['count', 'minutes']}
                            itemsType={translate('devices')}
                        />
                    </div>
                </Modal>
            )}
            {!!(selectedForDelete.length || selectedForAbort.length) && renderConfirmModal()}
        </Content>
    )
}

const exportReportTasks = checkAvailableModule('reports/tasks') ? ReportTasks : null

export default exportReportTasks
